// extracted by mini-css-extract-plugin
module.exports = {"base":"radio_base__15JJz","disabled":"radio_disabled__2sadx","fontSmall":"radio_fontSmall__6ygi0"};